import useMedia from 'hooks/useMedia';
import React, { Suspense, lazy } from 'react';
import Loader, { Variant as LoaderVariant } from 'components/Loader';

const LineitemsMobile = lazy(() => import('./Lineitems.mobile'));
const LineitemsDesktop = lazy(() => import('./Lineitems.desktop'));

type AppProps = {
  data: Record<string, any>;
  readOnly?: boolean;
};

const Accessories: React.FC<AppProps> = (props) => {
  const { isMobile } = useMedia();

  return (
    <Suspense
      fallback={
        <Loader
          variant={LoaderVariant.RoofLoader}
          label="Fetching Accessories..."
        />
      }
    >
      {isMobile ? (
        <LineitemsMobile {...props} />
      ) : (
        <LineitemsDesktop {...props} />
      )}
    </Suspense>
  );
};

export default Accessories;
